module.exports = __webpack_public_path__ + "img/sg.1413ed4f.jpg";